<template>
    <div class="create">
        <v-dialog :value="value.state" @click:outside="close" @keydown.esc="close" max-width="50%">
            <v-card>
                <v-card-title class="mb-5">
                    {{ value.item === undefined ? "Tạo mới " : "Cập nhật "}} tài sản
                </v-card-title>
                <v-card-text>
                    <v-form @submit.prevent="saveData" v-model="valid" ref="form">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                clearable color="teal"
                                v-model="form.name"
                                label="Tên"
                                ></v-text-field>

                                <v-text-field type="number"
                                clearable color="teal"
                                v-model="form.price"
                                label="Giá trị"
                                ></v-text-field>

                                <v-textarea
                                outlined color="teal"
                                v-model="form.note"
                                label="Ghi chú"
                                ></v-textarea>

                                <v-switch color="teal"
                                v-model="form.isActive"
                                label="Trạng thái"
                                ></v-switch>
                            </v-col>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn dark
                                color="blue darken-1"
                                type="submit"
                            >
                                Lưu
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>

import http from '@/components/services/http-common';
import * as moment from "moment/moment";

export default {
    components: {
    },
    props: ["value"],
    watch: {
        value: {
            handler(val){
                if(val.item != undefined)
                    this.fetchData();
            }
        },
        'form.minimumSalary': {
            handler(val)
            {
                this.form.minimumSalary7 = val* 107 /100;
            },
            deep:true,
        }
    },
    data() {
        return {

            // URL
            ROOT_URL: "properties/",
            
            //RULE
            rules: {
            },

            // DATA
            valid: false,
            formData: {
                cities: []
            },
            form: {
                name: "",
                price:0,
                note:"",
                isActive:false,
            },

            defaultForm: {
                name: "",
                price:0,
                note:"",
                isActive:false,
            },

            //EMPLOYEE DIALOG
            employeeDialog: false,
            selectedField: "",
        }
    },
    methods: {
        formatTime(value) {
            return moment(value).format("HH:mm:ss");
        },
        close () {
            this.$emit("CloseDialog");
            this.$refs.form.resetValidation();
            this.form = Object.assign({}, this.defaultForm);
        },

        saveData() {
            let  isValid = this.$refs.form.validate();
            if(isValid)
            {
                if(!this.value.item)
                {
                    http.post(this.ROOT_URL, this.form)
                    .then(res => {
                        this.$emit("fetchData");
                    })
                    .catch(err => {
                    });
                }else {
                    http.put(this.ROOT_URL+ this.value.item.code, this.form)
                    .then(res => {
                        this.$emit("fetchData");
                    })
                    .catch(err => {

                    });
                }
            }
        },

        fetchData() {
            return http.get(this.ROOT_URL + this.value.item.code)
            .then(res => {
                this.form = Object.assign({}, res.data.item)
            })
            .catch(err => {
                console.log(err);
            });
        },

    },
    created(){
    }
    
}
</script>